<script setup lang="ts">
/**
 * UI-kit component
 * Category: Buttons
 * Name: Primary
 * FIGMA: https://www.figma.com/design/CFyOwQUjj7uVRQTc03muvG/Demo-CS?node-id=212-73562&m=dev
 */
// types
import type { BtnPrimaryProps } from '../types/interfaces'
// hooks
import { useBtnPrimary } from '../composables/use-btn-primary.hook'

defineOptions({
  name: 'BtnPrimary',
})

const props = withDefaults(defineProps<BtnPrimaryProps>(), {
  disabled: false,
  color: 'blue',
  size: 'medium',
  elementWidth: 'auto',
})

const emit = defineEmits<{
  click: []
}>()

const {
  classList,
  handleClick,
} = useBtnPrimary({
  props,
  onClick: () => emit('click'),
})
</script>

<template>
  <button
    type="button"
    :class="classList"
    :disabled="disabled"
    @click="handleClick"
  >
    <slot name="iconLeft" />
    <span
      v-if="$slots.default"
      class="ui-btn-primary__text"
    >
      <slot />
    </span>
    <slot name="iconRight" />
  </button>
</template>

<style lang="scss" scoped src="../styles/_btn-primary.scss" />